import { TabPanelProps } from './types';

const TabPanel: React.FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
  className,
  unMount,
}) => {
  return (
    <div
      className={className}
      role='tabpanel'
      style={{
        display: value !== index ? 'none' : undefined,
      }}
    >
      {(!unMount || value === index) && children}
    </div>
  );
};

export default TabPanel;
